var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sdk-input',{style:(_vm.inputStyle),attrs:{"maxlength":4,"placeholder":_vm.placeholder},on:{"blur":_vm.onBlur,"focus":_vm.onFocus,"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }